module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/step-3_3fbc1dfb5988f0c75a904b55bb5f3f48.png";